var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "praise-rank-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-area" },
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "时间范围", prop: "timeRange" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "datetimerange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.searchForm.timeRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "timeRange", $$v)
                        },
                        expression: "searchForm.timeRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-area" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.tableLoading,
                    expression: "tableLoading",
                  },
                ],
                staticClass: "fixed-height-table",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, border: "", height: "500px" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "id",
                    label: "编号",
                    align: "center",
                    "min-width": "80",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "alias",
                    label: "用户名",
                    align: "center",
                    "min-width": "150",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "user-name" }, [
                            _vm._v(_vm._s(scope.row.alias || "匿名用户")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "content",
                    label: "评论内容",
                    align: "left",
                    "min-width": "250",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "content-preview" }, [
                            _vm._v(_vm._s(scope.row.content)),
                          ]),
                          _vm._v(" "),
                          scope.row.images && scope.row.images.length > 0
                            ? _c(
                                "div",
                                { staticClass: "images-container" },
                                _vm._l(scope.row.images, function (img, index) {
                                  return _c("el-image", {
                                    key: index,
                                    staticClass: "content-image",
                                    attrs: {
                                      src: _vm.getImageUrl(img),
                                      "preview-src-list": scope.row.images.map(
                                        _vm.getImageUrl
                                      ),
                                      fit: "cover",
                                    },
                                  })
                                }),
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "addTime",
                    label: "评论时间",
                    align: "center",
                    "min-width": "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "praiseNum",
                    label: "赞数",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "isTop",
                    label: "是否置顶",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                type:
                                  scope.row.isTop === 1 ? "success" : "info",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleToggleTop(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.isTop === 1 ? "是" : "否") +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "置顶时间",
                    align: "center",
                    "min-width": "180",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.isTop === 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatTopTime(
                                      scope.row.startTime,
                                      scope.row.endTime
                                    )
                                  )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "isTj",
                    label: "广场",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                type:
                                  scope.row.isTj === true ? "success" : "info",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAuditOrRecommend(
                                    scope.row,
                                    1
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    scope.row.isTj === true ? "是" : "否"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    label: "审核",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                type:
                                  scope.row.status === 1 ? "success" : "info",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAuditOrRecommend(
                                    scope.row,
                                    2
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.status === 1 ? "是" : "否") +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    "min-width": "150",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleViewDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v("查看")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemove(scope.row)
                                },
                              },
                            },
                            [_vm._v("移除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-area" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置置顶时间",
            visible: _vm.topDialogVisible,
            width: "500px",
            "before-close": function () {
              _vm.topDialogVisible = false
            },
          },
          on: {
            "update:visible": function ($event) {
              _vm.topDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.topDialogForm, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开始时间", prop: "startTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "请选择开始时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.topDialogForm.startTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.topDialogForm, "startTime", $$v)
                      },
                      expression: "topDialogForm.startTime",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "结束时间", prop: "endTime" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      placeholder: "请选择结束时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.topDialogForm.endTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.topDialogForm, "endTime", $$v)
                      },
                      expression: "topDialogForm.endTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.topDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveTopSetting },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "page-title" }, [_vm._v("赞排行")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }